module.exports = __webpack_public_path__ + "assets/img/mecha-55d91291.png";